<template>
  <form class="tools-partners-invite-modal p-5" @submit.prevent="submit">
    <div class="d-flex justify-content-between modal-title mb-5">
      {{ item && item.id ? "Editar colaborador" : "Adicionar colaborador" }}
      <button class="btn btn-sm" @click="$emit('close')">
        <i class="fa fa-close" />
      </button>
    </div>
    <form-group
      v-model="form.name"
      id="name"
      label="Nome do colaborador"
      placeholder="Digite o nome do colaborador"
      :errors="errors.name"
      :disabled="!!item && !!item.company"
    />

    <div class="row mt-5">
      <div class="col-lg-6">
        <form-group
          v-model="form.email"
          id="email"
          label="E-mail do colaborador"
          placeholder="Digite o e-mail do colaborador "
          :errors="errors.email"
          :disabled="!!item && !!item.id"
        />
      </div>
      <div class="col-lg-6">
        <action-dispatcher
          action="partnersCenter/getProfiles"
          :parameters="{ limit: 999 }"
        >
          <form-group
            v-model="form.perfil_id"
            select
            label="Perfil"
            id="form-perfil"
            placeholder="Selecione o perfil"
            :options="profiles"
          />
        </action-dispatcher>
      </div>
    </div>

    <b-form-checkbox switch v-model="form.is_admin" class="mt-5">
      Administrador
    </b-form-checkbox>

    <b-form-checkbox switch v-model="form.receive_notifications" class="mt-5">
      Receber notificações
    </b-form-checkbox>

    <span class="fs-12 text-neutral-500"
      >As notificações são referentes a e-mail, SMS e aplicativo mobile.</span
    >
    <div class="d-flex flex-column flex-lg-row justify-content-end mt-6">
      <button
        type="button"
        class="btn btn-new-secondary order-1 order-lg-0"
        @click="$emit('close')"
      >
        Cancelar
      </button>
      <button
        type="submit"
        class="btn ml-lg-5 mb-5 mb-lg-0"
        :disabled="!isValid"
        :class="isValid ? 'btn-primary' : 'btn-new-secondary'"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>
  </form>
</template>

<script>
import { formFields, updateArrayItem } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    item: Object
  },
  data() {
    return {
      ...formFields(
        ["email", "name", "perfil_id", "is_admin", "receive_notifications"],
        {
          ...(this.item || {})
        }
      )
    };
  },
  computed: {
    ...mapState("partnersCenter", ["profiles", "partners", "invitesSent"]),
    isValid() {
      return this.form.email && this.form.name && this.form.perfil_id;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      let action = this.postInvite;

      const data = (({
        email,
        name,
        perfil_id,
        is_admin,
        receive_notifications
      }) => ({
        email,
        name,
        perfil_id,
        is_admin,
        receive_notifications
      }))(this.form);

      if (this.item) {
        data.id = this.item.id;
        action = this.item.company ? this.updatePartner : this.putInvite;
      }
      try {
        await action(data);
      } catch (e) {
        this.errors = e.response.data;
      } finally {
        this.loading = false;
      }
    },
    async postInvite(data) {
      await this.$store.dispatch("partnersCenter/postInvite", data);
      this.$message.success("Convite enviado");
      this.$emit("close");
      this.$emit("reload");
    },
    async putInvite(data) {
      const response = await this.$store.dispatch(
        "partnersCenter/putInvite",
        data
      );
      this.$store.commit(
        "partnersCenter/setInvitesSent",
        updateArrayItem(this.invitesSent, response)
      );
      this.$message.success("Convite atualizado");
      this.$emit("close");
    },
    async updatePartner(data) {
      const response = await this.$store.dispatch(
        "partnersCenter/putPartner",
        data
      );
      this.$store.commit(
        "partnersCenter/setPartners",
        updateArrayItem(this.partners, response)
      );
      this.$message.success("Colaborador atualizado");
      this.$emit("close");
    }
  }
};
</script>
